// Cached email for magic-link signin. Wrapped with an expiry so a stolen
// or stale device cannot resume signin indefinitely. The Firebase email
// link itself expires in 1 hour; the cache lifetime is matched.
const TTL_MS = 60 * 60 * 1000; // 1h

interface Cached {
  email: string;
  expiresAt: number;
}

export function setCachedEmail(key: string, email: string): void {
  try {
    const value: Cached = { email, expiresAt: Date.now() + TTL_MS };
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // localStorage may be unavailable (private mode); fall back silently.
  }
}

export function getCachedEmail(key: string): string | null {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Cached>;
    if (
      typeof parsed?.email !== 'string' ||
      typeof parsed?.expiresAt !== 'number' ||
      parsed.expiresAt < Date.now()
    ) {
      localStorage.removeItem(key);
      return null;
    }
    return parsed.email;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function clearCachedEmail(key: string): void {
  try { localStorage.removeItem(key); } catch { /* noop */ }
}
